import { React, useEffect, useState, useContext } from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from '../../../../App';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { perVariationRuralAndUrbanwageIndex } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { changeDateFormat, isEndDateGreater } from "../../../../Custom/Custom";
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';
import {ruralWageRegionIndex} from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel'

const RuralWageRegionIndex = () => {
  // const token = useContext(MyContextProvider).token;
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportType, setReportType] = useState('');
  const [duration, setDuration] = useState('');
  const storedLanguage = localStorage.getItem('language');
  const monthMap = {
    'Jan': 'जनवरी',
    'Feb': 'फरवरी',
    'Mar': 'मार्च',
    'Apr': 'अप्रैल',
    'May': 'मई',
    'Jun': 'जून',
    'Jul': 'जुलाई',
    'Aug': 'अगस्त',
    'Sep': 'सितंबर',
    'Oct': 'अक्टूबर',
    'Nov': 'नवंबर',
    'Dec': 'दिसंबर'
  };
  // const config = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };
  const decode_token = getUserClaimsForUi();
  const token = decode_token;
  const config = getAuthHeaders();
  


  //Hamndle Onchange 
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fromDate":
        setFromDate(value);
        break;
      case "toDate":
        setToDate(value);
        break;
      case "report_type":
        setReportType(value);
        break;
      case "duration":
        setDuration(value);
        break;
      default:
        console.log("Case is not match")
    }

  }



  //handle excel sheet ***************
  const handleGenerateExcel = async () => {

    if (!fromDate || !toDate) {
      toast.error('Please select the Year range', messages.COLOR_RED);
      return;
    }
    if (!isEndDateGreater(fromDate, toDate)) {
      toast.error("To Year should be greater than From Year", messages.COLOR_RED);
      return;
    }

    if (reportType === '') {
      toast.error('Please select Report Type', messages.COLOR_RED);
      return
    }
    if (duration === '') {
      toast.error('Please select Group Type', messages.COLOR_RED);
      return
    }

    try {
      showLoading(true);
      let post_data = {
 

        "fromDate": fromDate,
        "toDate": toDate,
        "reportType": reportType,
        "duration": duration
      }
      const response = await axios.post(`${API_URL}api/price/RuralWageRegionIndex`, post_data, config);
      const reportData = response.data;
      if (reportData.status) {
        let allData = reportData.data.GroupCodes;
        downloadReport(allData, reportType,duration)

      } else {
        toast.error('Data is not found', messages.COLOR_RED);

      }

    } catch (error) {
      console.error(error);

    } finally {
      showLoading(false);
    }
  }

  const convertToHindi = (englishMonths) => {
    return englishMonths
        .split('-')
        .map(month => monthMap[month])
        .join('-');
  };

   //get Region name in English and Hindi
 const getRegionName = (region) => {
  const regionMap = {
      '00': ['State Region','राज्य क्षेत्र'],
      '01': ['Western Region','पशिचमी क्षेत्र'],
      '02': ['Central Region','मध्य क्षेत्र'],
      '03': ['Eastern Region','पूर्वी क्षेत्र'],
      '04': ['Bundelkhand Region','बुन्देलखण्ड क्षेत्र']
  };
   return regionMap[region] || ''; 
};
 

 //get Hindi name
 const getHindiName = (type) => {
    let yearType='';
      if(type==='AgricultureYear'){
        yearType="कृषि वर्ष";
      }else if(type==='FinancialYear'){
        yearType="वित्तीय वर्ष"
      }
   return yearType; 
};



  const downloadReport = (allData, reportType, duration) => {


    const transformedData = allData.map(item => {
      if (duration === '2') {
        return [
          getHindiName(item.Period),
          item.Year,
          item.CARPENTER === "" ? '0.00' : item.CARPENTER,
          item.MASON ==="" ? '0.00': item.MASON,
          item.AGRICULTURE_LABOUR ==="" ? '0.00': item.AGRICULTURE_LABOUR,
          item.Period,
          item.Year
        ];
      } else {
        // Default mapping for other durations
        return [
          convertToHindi(item.MONTH),
          item.YEAR,
          item.CARPENTER === "" ? '0.00' : item.CARPENTER,
          item.MASON ==="" ? '0.00': item.MASON,
          item.AGRICULTURE_LABOUR ==="" ? '0.00': item.AGRICULTURE_LABOUR,
          item.MONTH,
          item.YEAR
        ];
      }
    });
  // Determine the fileName based on the duration
  const fileName = duration === '2'
  ? `${getRegionName(reportType)[0].replace(/\s+/g, '')}IndexReport_Rural_Yearly(${fromDate}-${toDate})`
  : `${getRegionName(reportType)[0].replace(/\s+/g, '')}IndexReport_Rural_Quarterly(${fromDate}-${toDate})`;
    const excelObjectData = {
      fileName: fileName,
      fileType: 'xls',
      sheetName: `RuralRegionIndexReport${duration === '2'?'Yearly':'Quarterly'}`,
      firstRowMergeCells: 'A1:G1',
      firstRowExportDate: changeDateFormat(new Date()),
      secondRowMergeCells: 'A2:G2',
      secondRowText: `सारिणी -2 ग्रामीण मजदूरी दर  के सूचकांक ${getRegionName(reportType)[1]} ( कृषि  वर्ष 2011-12=100) `,
      thirdRowMergeCells: 'A3:G3',
      thirdRowText: ` Table-2 Rural  wage index of ${getRegionName(reportType)[0]} (Agriculture Year 2011-12=100) `,
      headerColumn:[ 'अवधि', '', 'CARPENTER', 'MASON', 'AGRICULTURE LABOUR', 'Period',''],
      excelRowData: transformedData,
    };

    excelObjectData.excelRowData = transformedData;
    ruralWageRegionIndex(excelObjectData);
  }


  //get years
  const getAllYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= 2010; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };

  return (
    <>
      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.RURAL_WAGEREGION_INDEX_REPORT : priceTitle.en.RURAL_WAGEREGION_INDEX_REPORT }} />
              </h4>
              <div className="row align-items-center">

                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label>  Select Year Range </label>

                  <select name="fromDate"
                    className="form-select"
                    onChange={handleOnChange}
                    value={fromDate}
                  >
                    <option value="" disabled>[---Select--]</option>
                    {getAllYears().map((ele, index) => (
                      <option key={index} value={ele}>
                        {ele}
                      </option>
                    ))}
                  </select>
                  </div>
                 
                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>  To </label>

                  <select
                    name="toDate"
                    className="form-select"
                    onChange={handleOnChange}
                    value={toDate}
                  >
                    <option value="" disabled>[---Select--]</option>
                    {getAllYears().map((ele, index) => (
                      <option key={index} value={ele}>
                        {ele}
                      </option>
                    ))}
                  </select>
                  </div>


                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label> Select Region</label>

                  <select
                    name="report_type"
                    className="form-select"
                    onChange={handleOnChange}
                    value={reportType}
                  >
                    <option value="" disabled>[---Select--]</option>
                    <option value="00">State Region</option>
                    <option value="01">Western Region</option>
                    <option value="02">Central Region</option>
                    <option value="03">Eastern Region</option>
                    <option value="04">Bundelkhand Region</option>
                  </select>

                </div>


                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label> Select Report Year</label>

                  <select
                    name="duration"
                    className="form-select"
                    onChange={handleOnChange}
                    value={duration}
                  >
                    <option value="" disabled>[---Select--]</option>
                    <option value="1">Quarterly</option>
                    <option value="2">Yearly</option>
                  </select>

                </div>





                <div className="col-xl-2 col-lg-4 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  )
}


export default RuralWageRegionIndex